import { Fragment, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import { Link, generatePath } from 'react-router-dom';
import { RouterPaths } from '../../app/appConstants';
import { getAppLoggedIn, getAppPartner } from '../Auth/authSelectors.js';
import { logoutAction } from '../Auth/authActions.js';
import { HeaderAccountStyled, HeaderBurgerStyled, HeaderStyled } from './styled/HeaderStyled';
import appHistory from '../../app/appHistory.js';
import Menu from '../Menu/Menu.jsx';
import amountFormat from '../../utils/amountFormat.js';
import { useLangContext } from '../../providers/LangProvider/LangProviderContext.js';
import { BinIcon } from '../../components/Icon/Icon';
import { useResponsive } from '../../components/responsive/index.js';
import { Slider } from '../../components/Slider/Slider.jsx';
import { MENU_ITEMS } from '../Menu/menuConstants.js';
import logoUrl from '../../assets/landing/affilers_logotype.svg?url';

function Header() {
    const { getLangPath } = useLangContext();
    const loggedIn = useSelector(getAppLoggedIn);
    const dispatch = useDispatch();
    const partnerInfo = useSelector(getAppPartner);
    const { isLargeMinWidth } = useResponsive();

    const logoutHandler = useCallback(() => {
        dispatch(logoutAction());
    }, [dispatch]);

    const logoClickHandler = useCallback(() => {
        appHistory.push(RouterPaths.main);
    }, []);

    return (
        <HeaderStyled>
            <div className="logo" onClick={logoClickHandler}>
                <img src={logoUrl} alt="Affilers" width="80" height="24" />
            </div>

            {!!isLargeMinWidth && <div className="menu">{!!loggedIn && <Menu />}</div>}

            <HeaderAccountStyled>
                {!!loggedIn && (
                    <Link
                        to={RouterPaths.balanceLogs}
                        className="balance"
                        title={getLangPath('profile.partner_balance')}
                    >
                        <span className="balance-label">{getLangPath('profile.partner_balance')}</span>
                        <span className="balance-value">${amountFormat(partnerInfo.balance)}</span>
                    </Link>
                )}

                {!!isLargeMinWidth && loggedIn && (
                    <Button variant="outline" className="logout" onClick={logoutHandler}>
                        {getLangPath('menu.logout')}
                        <BinIcon name="IcLogOut" />
                    </Button>
                )}

                {!isLargeMinWidth && loggedIn && (
                    <Slider
                        toggleComponent={<BinIcon name="IcMenuBurger" stroke="var(--color-white)" />}
                        toggleWrapperClassname="flex-grow-0"
                    >
                        <Slider.CloseWrapper>
                            <HeaderBurgerStyled>
                                {MENU_ITEMS.map((item) => (
                                    <Fragment key={item.name}>
                                        <Link to={generatePath(item.path)} className="dropdown-item">
                                            {getLangPath(`menu.${item.name}`)}
                                        </Link>
                                    </Fragment>
                                ))}
                                <Slider.Row className="dropdown-item" onClick={logoutHandler}>
                                    <Link to="#/">{getLangPath('menu.logout')}</Link>
                                </Slider.Row>
                            </HeaderBurgerStyled>
                        </Slider.CloseWrapper>
                    </Slider>
                )}
            </HeaderAccountStyled>
        </HeaderStyled>
    );
}

export default Header;
